import React from 'react';

import classNames from 'classnames';

import { Layout } from 'wanderu-components';
import { getDateRange } from 'wanderu-utils';

import DayButton from './DayButton/DayButton';

import styles from './MultiDay.scss';

export interface SearchParams {
    departDate: string;
    departTripId?: string;
    destinationPlaceId?: string;
    destinationText: string;
    direction: string;
    originPlaceId?: string;
    originText: string;
    returnDate?: string;
}

interface MultiDayProps {
    searchParams: SearchParams;
    isDesktop?: boolean;
}

export const MultiDay = ({
    searchParams,
    isDesktop,
}: MultiDayProps) => {
    const { departDate, direction } = searchParams;
    const dateRange = getDateRange(departDate);

    if (direction === 'return') return null;

    return (
        <Layout className={classNames(styles.days, {
            [styles.desktop]: isDesktop,
        })}>
            {dateRange.map(({ date, isActive, isDisabled }) => (
                <DayButton
                    date={date}
                    isActive={isActive}
                    isDisabled={isDisabled}
                    key={date}
                    searchParams={searchParams}
                />
            ))}
        </Layout>
    );
};
